import { motion } from "framer-motion";

const steps = [
  { num: "01", title: "Klik Beli Sekarang", desc: "Kamu langsung diarahkan ke halaman checkout." },
  { num: "02", title: "Selesaikan Pembayaran", desc: "Bayar Rp59.000 dengan metode favoritmu." },
  { num: "03", title: "Akun Dikirim via WhatsApp", desc: "Proses instan — detail akun langsung masuk ke WA kamu." },
  { num: "04", title: "Login & Mulai Edit", desc: "Semua fitur Pro terbuka. Gas bikin konten!" },
];

export const CapCutSteps = () => (
  <section className="py-24 bg-[#F8FAFC]" id="capcut-langkah">
    <div className="max-w-6xl mx-auto px-6 sm:px-8">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-capcut-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900 text-center mb-14"
      >
        4 langkah, langsung <span className="text-blue-600">Pro</span>.
      </motion.h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((step, i) => (
          <motion.div
            key={step.num}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl bg-white border border-slate-200 p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(37,99,235,0.1)] hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
            data-testid={`capcut-step-${i + 1}`}
          >
            <span className="font-capcut-heading text-4xl font-black text-blue-100">{step.num}</span>
            <h3 className="mt-3 font-capcut-heading text-lg font-bold text-slate-900">{step.title}</h3>
            <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{step.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
